export const CASH_DEPOSIT_PERMISSION = {
  VIEW: 'AC_CASH_DEPOSIT_VIEW',
  VIEW_ALL: 'AC_CASH_DEPOSIT_VIEW_ALL',
  ADD: 'AC_CASH_DEPOSIT_ADD',
  EDIT: 'AC_CASH_DEPOSIT_EDIT',
  SUBMIT: 'AC_CASH_DEPOSIT_SUBMIT',
  CONFIRM: 'AC_CASH_DEPOSIT_CONFIRM',
  CANCEL: 'AC_CASH_DEPOSIT_CANCEL',
};

export const CASH_DEPOSIT_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
};

export const CASH_DEPOSIT_STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  { value: CASH_DEPOSIT_STATUS.DRAFT, label: 'Nháp' },
  { value: CASH_DEPOSIT_STATUS.SUBMITTED, label: 'Chờ ngân hàng ghi Có' },
  { value: CASH_DEPOSIT_STATUS.CONFIRMED, label: 'Đã vào ngân hàng' },
  { value: CASH_DEPOSIT_STATUS.CANCELLED, label: 'Đã hủy' },
];

export const cashDepositStatusLabel = (status) =>
  CASH_DEPOSIT_STATUS_OPTIONS.find((item) => item.value === status)?.label || status;
